(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("StartInterviewEvaluationModal", StartInterviewEvaluationModal);

    StartInterviewEvaluationModal.$inject = ['$scope', 'hUser', 'hFormsService', 'interviewBankDataService', 'modalData', 'startEvaluation'];

    function StartInterviewEvaluationModal($scope, hUser, hFormsService, interviewBankDataService, modalData, startEvaluation) {

        var self = this;

        self.brandId = modalData.brandId;
        self.applicationId = modalData.applicationId;
        self.positionName = modalData.positionName;
        self.positionCode = modalData.positionCode;
        self.jobId = modalData.jobId;
        self.evaluationType = modalData.evaluationType;
        self.preStarted = modalData.preStarted;

        self.loading = true;
        self.chosenTemplate = {};
        self.interviewTemplates = [];
        self.templateError = false;

        self.startEvaluation = function () {

            if (self.chosenTemplate && self.chosenTemplate.id) {

                createEvaluation(self.chosenTemplate.id);
            }
            else {
                self.templateError = true;
            }
        };

        self.onSelectTemplate = function () {
            if (self.templateError) {
                self.templateError = false;
            }
        };

        self.close = function () {
            $scope.$hide();
        };

        var createEvaluation = function (templateId) {

            self.loading = true;

            interviewBankDataService
                .startEvaluation(self.brandId, self.applicationId, templateId, self.evaluationType)
                .then(function (data) {

                    startEvaluation(data.evaluation.id);
                    self.loading = false;
                    self.close();

                }, function (err) {
                    console.error(err);
                });
        };

        var getBrandTemplates = function () {

            var positions = [self.positionCode];
            var types = [self.evaluationType];
            var brandId = self.brandId;
            var filterBy = 'ALL';
            var statuses = ['ACTIVE'];

            interviewBankDataService
                .getAllTemplates(brandId, null, null, types, positions, null, null, filterBy, statuses)
                .then(function (templatesDetails) {

                    self.interviewTemplates = templatesDetails.templates;

                    if (self.interviewTemplates.length === 1) {
                        createEvaluation(self.interviewTemplates[0].id);
                    }
                    else {
                        self.loading = false;
                    }
                });
        };

        if (self.preStarted) {
            /**
             * If another interviewer already started and evaluation
             * then a template is already chosen and no new template should be chosen
             * which will send only the type of the evaluation needed to start
             */
            createEvaluation();
        }
        else {
            /**
             * First check if the job has a template attached
             * if attached then pass template id to start interview
             * else get brand templates and choose 1 from them
             * of Type === the type of the evaluation needed
             */
            interviewBankDataService
                .getJobAttachedTemplates(self.brandId, self.jobId)
                .then(function (templates) {

                    if (templates && templates.length) {

                        var templateOfType = _.findWhere(templates, {type: self.evaluationType});

                        if (templateOfType) {
                            createEvaluation(templateOfType.id);
                        }
                        else {
                            getBrandTemplates();
                        }
                    }
                    else {
                        getBrandTemplates();
                    }
                })
                .catch(function (reason) {
                    console.error(reason);
                });
        }
    }
})();